import { styled } from 'styled-components';

import CatImage from '../../../static/svgIcons/Cat.svg';
import DividerSvg from '../../../static/svgIcons/Divider.svg';
import DogImage from '../../../static/svgIcons/Dog.svg';
import PinkPhoneSvg from '../../../static/svgIcons/PinkPhone.svg';
import pawPrintsBackground from '../../images/background_paw_prints.png';
import {
  colors,
  fontFamilyCamptonMedium,
  fontFamilyCamptonSemiBold,
} from '../../styles/sharedStyled';

export const MoreInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 45px 24px 95px;
  box-sizing: border-box;
  position: relative;
  background-color: ${colors.tan1};
  overflow: hidden;
  background-image: url(${pawPrintsBackground});

  @media (min-width: 768px) {
    padding: 60px 40px 90px;
    align-items: center;
  }

  @media (min-width: 1024px) {
    padding: 90px 0 120px;
    margin: 0 auto;
  }
`;

export const MoreInfoTitle = styled.h1`
  font-size: 35px;
  font-family: ${fontFamilyCamptonMedium};
  margin-bottom: 24px;
  line-height: normal;
  text-align: center;

  @media (min-width: 768px) {
    font-size: 40px;
    line-height: 48px;
  }

  @media (min-width: 1024px) {
    font-size: 56px;
    line-height: 70px;
    margin-bottom: 32px;
  }
`;

export const MoreInfoParagraph = styled.p<{
  $hasDesktopMargin?: boolean;
  $isTop?: boolean;
}>`
  font-size: 18px;
  font-family: ${fontFamilyCamptonMedium};
  margin-bottom: 24px;
  line-height: 30px;
  text-align: center;

  @media (min-width: 768px) {
    margin-bottom: 32px;
    width: ${({ $isTop }) => ($isTop ? '715px' : '539px')};
  }

  @media (min-width: 1150px) {
    margin-bottom: ${({ $isTop }) => $isTop && '48px'};
    width: ${({ $isTop }) => ($isTop ? '1050px' : '914px')};
  }
`;

export const MoreInfoLinksContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (min-width: 768px) {
    flex-direction: row;
  }
`;

export const MoreInfoLinks = styled.a`
  font-size: 18px;
  font-family: ${fontFamilyCamptonSemiBold};
  line-height: 23px;
  color: ${colors.pink2};
  text-decoration: underline;

  &:first-child {
    margin-bottom: 14px;
  }

  @media (min-width: 768px) {
    line-height: 21px;

    &:first-child {
      margin-bottom: 0;
    }
  }

  @media (min-width: 1024px) {
    line-height: 30px;
  }
`;

export const PhoneContainer = styled.div`
  display: flex;
`;

export const PhoneSvg = styled(PinkPhoneSvg)`
  width: 24px;
  height: 25px;
  margin-right: 8px;
  margin-top: -4px;

  @media (min-width: 1024px) {
    margin-right: 4px;
    margin-top: 1px;
  }
`;

export const Divider = styled(DividerSvg)`
  @media (min-width: 768px) {
    margin: 0 24px;
  }
`;

export const TabletDogSvg = styled(DogImage)`
  position: absolute;
  width: 240px;
  height: 350px;
  left: -50px;
  bottom: -36px;
`;

export const DesktopDogSvg = styled(DogImage)`
  display: none;

  @media (min-width: 1500px) {
    display: block;
    position: absolute;
    width: 486px;
    height: 729px;
    left: -65px;
    bottom: -2px;
  }
`;

export const CatSvg = styled(CatImage)`
  display: none;

  @media (min-width: 1500px) {
    display: block;
    position: absolute;
    width: 438px;
    height: 202px;
    bottom: 0;
    right: 4px;
  }
`;

export const MobileCatImageContainer = styled.div`
  position: absolute;
  width: 129px;
  height: 94px;
  right: 0;
  bottom: 0;
`;

export const TabletCatImageContainer = styled.div`
  position: absolute;
  width: 175px;
  height: 85px;
  right: 4px;
  bottom: 0;
`;

export const MobileDogImageContainer = styled.div`
  position: absolute;
  width: 129px;
  height: 81px;
  left: 0;
  bottom: 0;
`;
